const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_public/reset-password.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_public/reset-password')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});